// store/authStore.js
import { create } from "zustand";
import { getEarthWorkData } from "../api/earthWork";
import { getContact, postContact, postContactInfo } from "../api/contact";

export const useContactStore = create((set, get) => ({
    loading: true,
    contact: null,

    getContact: async () => {
        try {
            set({ loading: true })
            const res = await getContact()
            set({ loading: false, contact: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    postContact: async (form) => {
        try {
            set({ loading: true })
            const res = await postContactInfo(form)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ loading: false });
            return false;
        } finally {
            set({ loading: false });
        }
    }

}));
